import * as React from 'react';
import { Logo } from './Logo.js';
import { Anchor } from '../../components/Anchor/index.js';
export var PageHeader = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? React.createElement(Logo, null) : _b, _c = _a.home, home = _c === void 0 ? '/' : _c, _d = _a.fluid, fluid = _d === void 0 ? false : _d, children = _a.children;
    return (React.createElement("header", { className: fluid ? 'fluid smp-header' : 'sticky smp-header' },
        React.createElement("nav", { className: "container row" },
            React.createElement("div", { className: "row header-brand" },
                React.createElement(Anchor, { url: home, className: "navbar-brand" }, logo),
                React.createElement("input", { type: "checkbox", id: "header-hamburger-open" }),
                React.createElement("div", { className: "navbar-toggler" },
                    React.createElement("label", { htmlFor: "header-hamburger-open", "data-toggle": "collapse", "aria-controls": "navbar-menu-content", "aria-label": "Toggle navigation" },
                        React.createElement("i", { className: "fas fa-bars" })))),
            children)));
};
//# sourceMappingURL=PageHeader.js.map